import { ConditionType } from '../../types'
import PropertyCondition from './SetPropertyCondition'

export default class IsSetPropertyCondition extends PropertyCondition {
  type!: ConditionType.IsSetProperty
}
